import React, {
    Fragment,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import {
    arrayPush,
    Field,
    getFormSyncErrors,
    getFormValues,
    reduxForm,
} from 'redux-form';
import SwiperImage from '../../meeting/container/manageMeetingRoom/MeetingSwiperImage';
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    IconButton,
    makeStyles,
} from '@material-ui/core';
import TextFields from '../../../control/textfield/TextFields';
import { keyEnterSubmitForm } from '../../../utilities/FormUtils';
import QuillEditorField from '../../../control/quillEditorField/QuillEditorField';
import DatePicker from '../../../control/fdatetime/DateflatPicker';
import TimePicker from '../../../control/fdatetime/TimeFlatePicker';
import { Divider } from 'antd';
import UploadExcelPreRegister from './UploadExcelPreRegister';
import { useDispatch, useSelector } from 'react-redux';
import 'react-quill/dist/quill.snow.css';
import AutoComplete from '../../../control/autocomplete/AutoComplete';
import {
    optionIsPublic,
    optionIsRequiredCheckIn,
    validateEventForm,
} from '../FormUtils';
import * as FocusActions from '../../../actions/FocusAction';
import classNames from 'classnames';
import RadioToggleButton from '../../../control/radio/RadioToggleButton';
import CloseIcon from '@material-ui/icons/Close';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import moment from 'moment';
import { RESERVE_FILE_TEMPLATE } from '../../../constants/ApiConstants';

const useStyles = makeStyles((theme) => ({
    gridContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    title: {
        fontSize: '26px',
        weight: '400',
        borderBottom: '2px solid #F47B15',
        marginBottom: '32px',
    },
    spacing: {
        ...theme.form.spacing,
    },
    dateTimeContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            width: '100%',
            alignItems: 'flex-start',
            gap: '4px',
        },
    },
    dateTimeContainerField: {
        width: '100%',
        height: 'auto !important',
        [theme.breakpoints.down('sm')]: {
            flex: 1,
        },
    },
    formHelper: {
        color: theme.mainTheme.color5,
        fontSize: '17px',
        marginTop: '4px',
    },
    reserveFormHelper: {
        color: theme.mainTheme.color5,
        fontSize: '17px',
    },
    divider: {
        margin: '24px 0px',
    },
    grid4: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: 'repeat(1, 1fr)',
        },
    },
    label: {
        color: theme.mainTheme.color1,
        fontSize: '20px',
    },
    colorErr: {
        color: theme.mainTheme.color5,
    },
    maintainerList: {
        minWidth: '48px',
        minHeight: 'auto',
        borderRadius: '24px',
        // backgroundColor: '#B8D3D7',
        padding: ' 0px 5px 0px 15px',
        margin: '0px 5px 5px 5px',
        boxShadow: 'rgba(0, 0, 0, 0.4) 0px 3px 7px 0px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'defaul',
        border: '1px solid #df7923e6',
    },
    buttonFab: {
        width: '20px',
        height: '20px',
        padding: '0px',
    },
    extendedIcon: {
        width: '20px',
        height: '20px',
    },
    helperTextLabel: {
        marginLeft: '12px',
        color: '#000000',
        opacity: '60%',
        fontSize: '15px',
    },
    fontLabel: {
        fontSize: '20px',
    },
    gridTextField: {
        height: '35px',
    },
    hidden: {
        display: 'none',
    },
}));

const formId = 'EventCreateEditForm';

const isPublicAffectedFields = [
    'reserveStartDate',
    'reserveStartTime',
    'reserveEndDate',
    'reserveEndTime',
    'internalCapacity',
    'externalCapacity',
];

const defaultValues = {
    isRequiredCheckin: true,
    checkInLeadTime: 30,
    isPublic: true,
    internalCapacity: 0,
    externalCapacity: 0,
    internalRequired: false,
    externalRequired: false,
};

const EventCreateEditForm = ({
    handleSubmit,
    initialize,
    reset,
    change,
    lookups,
    onSubmit,
    isEdit,
    submitFailed,
    initialValues,
    tempDate,
    isLookupUserLoading,
    authenRdc,
}) => {
    const classes = useStyles();
    const values = useSelector((state) => getFormValues(formId)(state));
    const errorState = useSelector((state) => getFormSyncErrors(formId)(state));
    const initializedRef = useRef(false);
    const dispatch = useDispatch();
    const isInternalCapacityTouched = useSelector((state) => {
        return (
            state.form &&
            state.form[formId] &&
            state.form[formId].fields &&
            state.form[formId].fields.internalCapacity &&
            state.form[formId].fields.internalCapacity.touched
        );
    });

    const isExternalCapacityTouched = useSelector((state) => {
        return (
            state.form &&
            state.form[formId] &&
            state.form[formId].fields &&
            state.form[formId].fields.externalCapacity &&
            state.form[formId].fields.externalCapacity.touched
        );
    });

    const [lutEmpCoordinators, setLutEmpCoordinators] = useState();
    const [lutMainCoordinators, setLutMainCoordinators] = useState();
    const [checkedInternal, setCheckedInternal] = useState(true);
    const [checkExternal, setCheckedExternal] = useState(true);

    useEffect(() => {
        if (initialValues && isEdit && !initializedRef.current) {
            initialize({ ...initialValues });
            initializedRef.current = true;
            if (initialValues.internalCapacity !== null) {
                setCheckedInternal(false);
                dispatch(change('internalRequired', true));
            } else {
                setCheckedInternal(true);
                dispatch(change('internalCapacity', 0));
                dispatch(change('internalRequired', false));
            }
            if (initialValues.externalCapacity !== null) {
                setCheckedExternal(false);
                dispatch(change('externalRequired', true));
            } else {
                setCheckedExternal(true);
                dispatch(change('externalCapacity', 0));
                dispatch(change('externalRequired', false));
            }
            // inject internal/external ReserveCount
            dispatch(
                change(
                    'internalReservedCount',
                    initialValues.internalReservedCount
                )
            );
            dispatch(
                change(
                    'externalReservedCount',
                    initialValues.externalReservedCount
                )
            );
        } else if (!initialValues) {
            initialize({ ...defaultValues });
            setCheckedInternal(true);
            setCheckedExternal(true);
        }
    }, [initialValues, isEdit]);

    useEffect(() => {
        setLutEmpCoordinators(lookups.internalUser);
        if (!isEdit && lookups.internalUser) {
            dispatch(change('mainCoordinator', authenRdc.profile.uuid));
        }
    }, [lookups, isEdit]);

    const updateLutMaintainer = useCallback(() => {
        const { coordinators = [], mainCoordinator } = values || {};

        const coordinatorIdsMain = new Set(coordinators.map((c) => c.userId));
        const coordinatorIdsCoord = new Set(coordinatorIdsMain);
        if (mainCoordinator) {
            coordinatorIdsCoord.add(mainCoordinator);
        }

        const mainCoordinatorOptions = lookups.internalUser.filter(
            (user) => !coordinatorIdsMain.has(user.userId)
        );

        const coordinatorOptions = lookups.internalUser.filter(
            (user) => !coordinatorIdsCoord.has(user.userId)
        );

        setLutMainCoordinators(mainCoordinatorOptions);
        setLutEmpCoordinators(coordinatorOptions);
    }, [lookups, values]);

    useEffect(() => {
        if (
            values &&
            (Array.isArray(values.coordinators) || values.mainCoordinator)
        ) {
            updateLutMaintainer();
        }
    }, [values, updateLutMaintainer]);

    const onChangeCoordinatorsForms = async (value) => {
        if (value) {
            const tmpCoord = Array.isArray(values.coordinators)
                ? values.coordinators.filter(
                      (item) => item && typeof item === 'object'
                  )
                : [];

            const alreadyExists = tmpCoord.some(
                (item) => item.userId === value.userId
            );

            if (!alreadyExists) {
                dispatch(arrayPush(formId, 'coordinators', value));
            }
            await change('coordinatorTemp', null);
            const el = document.getElementById('search-maintainer-event');
            if (el) el.blur();
        }
    };

    const onClickRemoveCoordinators = (value) => {
        const newValue = values.coordinators.filter(
            (item) => item.userId !== value.userId
        );
        change('coordinators', newValue);
    };

    const handleChangeExcelFile = useCallback(
        async (excelFileData) => {
            await change('reserveFile', excelFileData);
        },
        [change]
    );

    const handleChangeDate = useCallback(
        function (field) {
            return function (value) {
                if (!value) return;
                switch (field) {
                    case 'eventStartDate':
                        if (
                            values.eventEndDate &&
                            moment(value).isAfter(moment(values.eventEndDate))
                        ) {
                            change('eventEndDate', value);
                        }

                        const newEventStart = moment(value);

                        if (
                            values.reserveStartDate &&
                            moment(values.reserveStartDate).isAfter(
                                newEventStart
                            )
                        ) {
                            change('reserveStartDate', value);
                        }

                        if (
                            values.reserveEndDate &&
                            moment(values.reserveEndDate).isAfter(newEventStart)
                        ) {
                            change('reserveEndDate', value);
                        }

                        if (
                            values.reserveStartDate &&
                            values.reserveEndDate &&
                            moment(values.reserveStartDate).isAfter(
                                moment(values.reserveEndDate)
                            )
                        ) {
                            change('reserveStartDate', value);
                        }

                        break;

                    case 'eventEndDate':
                        if (
                            values.eventStartDate &&
                            value < values.eventStartDate
                        ) {
                            change('eventStartDate', value);
                        }
                        if (
                            values.reserveEndDate &&
                            moment(values.reserveEndDate).isAfter(value)
                        ) {
                            change('reserveEndDate', value);
                        }
                        break;

                    case 'reserveStartDate':
                        if (
                            values.reserveEndDate &&
                            value > values.reserveEndDate
                        ) {
                            change('reserveEndDate', value);
                        }
                        if (
                            values.eventStartDate &&
                            value > values.eventStartDate
                        ) {
                            change('reserveStartDate', values.eventStartDate);
                        }
                        break;

                    case 'reserveEndDate':
                        if (
                            values.reserveStartDate &&
                            value < values.reserveStartDate
                        ) {
                            change('reserveStartDate', value);
                        }
                        if (
                            values.eventStartDate &&
                            value > values.eventStartDate
                        ) {
                            change('reserveEndDate', values.eventStartDate);
                        }
                        break;

                    default:
                        break;
                }

                change(field, value);
            };
        },
        [values, change]
    );

    const handleChangeIsPublicResetRelatedFields = useCallback(
        (event, newValue, previousValue) => {
            if (newValue === false) {
                for (const field of isPublicAffectedFields) {
                    dispatch(change(field, null));
                }
            } else {
                setCheckedInternal(true);
                dispatch(change('internalCapacity', 0));
                dispatch(change('internalRequired', false));
                setCheckedExternal(true);
                dispatch(change('externalCapacity', 0));
                dispatch(change('externalRequired', false));
            }
        },
        [dispatch, change]
    );

    const disabledStartDateFunction = useCallback(
        function (date) {
            if (!values) return false;

            if (moment(date).isSame(moment(tempDate.eventStartDate))) {
                return false;
            }
            return moment(date).isSameOrBefore(moment(), 'day');
        },
        [values, tempDate, initialValues]
    );

    const disabledEndDateFunction = useCallback(
        function (date) {
            if (moment(date).isSame(moment(tempDate.eventEndDate))) {
                return false;
            }
            if (
                moment(date).format('YYYY-MM-DD') ===
                moment(tempDate.eventEndDate).format('YYYY-MM-DD')
            ) {
                return false;
            }
            if (!values || !values.eventStartDate) {
                return moment(date).isSameOrBefore(moment(), 'day');
            }
            return moment(date).isBefore(moment(values.eventStartDate), 'day');
        },
        [values, tempDate]
    );

    const disabledReserveStartFunction = useCallback(
        function (date) {
            if (
                (isEdit && !tempDate.reserveStartDate) ||
                (moment(date).isSameOrAfter(
                    moment(tempDate.reserveStartDate),
                    'day'
                ) &&
                    moment(date).isBefore(
                        moment(tempDate.eventStartDate),
                        'day'
                    ))
            ) {
                return false;
            }
            if (!values || !values.eventStartDate) {
                return moment(date).isBefore(moment(), 'day');
            }
            return (
                moment(date).isBefore(moment(), 'day') ||
                moment(date).isAfter(moment(values.eventStartDate), 'day')
            );
        },
        [values, tempDate]
    );

    const disabledReserveEndFunction = useCallback(
        function (date) {
            if (
                moment(date).format('YYYY-MM-DD') ===
                moment(tempDate.reserveEndDate).format('YYYY-MM-DD')
            ) {
                return false;
            }
            if (!values || !values.reserveStartDate || !values.eventStartDate) {
                return moment(date).isBefore(moment(), 'day');
            }
            return (
                moment(date).isBefore(moment(), 'day') ||
                moment(date).isBefore(moment(values.reserveStartDate), 'day') ||
                moment(date).isAfter(moment(values.eventStartDate), 'day')
            );
        },
        [values, tempDate]
    );

    const isShowHelperTextStartEnd = useMemo(() => {
        if (values && values.eventStartDate && values.eventEndDate) {
            const start = moment(values.eventStartDate);
            const end = moment(values.eventEndDate);

            return end.diff(start, 'days') > 0;
        } else {
            return false;
        }
    }, [values]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container>
                <Grid container className={classes.gridContainer}>
                    <Field
                        name={'coverImage'}
                        component={SwiperImage}
                        stepperSwipe={false}
                        limit={1}
                        accept={'.jpg,.jpeg,.png'}
                    />
                    <Grid
                        item
                        xs={12}
                        style={{
                            fontSize: '15px',
                            color: 'red',
                            textAlign: 'center',
                        }}
                    >
                        *ขนาดไฟล์สูงสุดไม่เกิน 5MB, จำนวนไม่เกิน 1 รูป,
                        รองรับไฟล์นามสกุล .jpeg, .jpg, .png เท่านั้น,
                        อัตราส่วนรูปภาพที่แนะนำ 16:9
                    </Grid>
                </Grid>
                <div className={classes.title}>รายละเอียดกิจกรรม</div>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={6} className={classes.spacing}>
                        <Field
                            name="eventName"
                            label="ชื่อกิจกรรม"
                            component={TextFields}
                            placeholder="กรุณาระบุ"
                            maxLength={100}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={6} className={classes.spacing}>
                        <Field
                            name="venue"
                            label="สถานที่จัดกิจกรรม"
                            component={TextFields}
                            placeholder="กรุณาระบุ"
                            maxLength={100}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {/* ความยาวไม่เกิน 1000 char */}
                        <Field
                            name="eventDescription"
                            label="รายละเอียดกิจกรรม"
                            component={QuillEditorField}
                            placeholder="กรุณาระบุ"
                            maxLength={1000}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {/* ความยาวไม่เกิน 250 char */}
                        <Field
                            name="speakers"
                            label="ข้อมูลวิทยากร"
                            component={QuillEditorField}
                            placeholder="กรุณาระบุ"
                            maxLength={250}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Box className={classes.dateTimeContainer}>
                            <Field
                                name="eventStartDate"
                                label="วันที่เริ่มกิจกรรม"
                                component={DatePicker}
                                placeholder="วัน/เดือน/ปี"
                                required
                                className={classes.dateTimeContainerField}
                                onChange={handleChangeDate('eventStartDate')}
                                disabledDateFunction={disabledStartDateFunction}
                            />
                            <Field
                                name="eventStartTime"
                                label="เวลาเริ่มต้น"
                                component={TimePicker}
                                placeholder="กรุณาระบุ"
                                required
                                className={classes.dateTimeContainerField}
                                defaultTime={
                                    new Date(new Date().setHours(0, 0, 0, 0))
                                }
                            />
                            <div style={{ padding: '6px', marginTop: '28px' }}>
                                ถึง
                            </div>
                            <Field
                                name="eventEndDate"
                                label="วันที่สิ้นสุดกิจกรรม"
                                component={DatePicker}
                                placeholder="วัน/เดือน/ปี"
                                required
                                className={classes.dateTimeContainerField}
                                onChange={handleChangeDate('eventEndDate')}
                                disabledDateFunction={disabledEndDateFunction}
                            />
                            <Field
                                name="eventEndTime"
                                label="เวลาสิ้นสุด"
                                component={TimePicker}
                                placeholder="กรุณาระบุ"
                                required
                                className={classes.dateTimeContainerField}
                                defaultTime={
                                    new Date(new Date().setHours(0, 0, 0, 0))
                                }
                            />
                        </Box>
                        {isShowHelperTextStartEnd && (
                            <Grid container>
                                <Grid item xs={12} md={12}>
                                    <FormHelperText
                                        className={classes.formHelper}
                                    >
                                        *ในแต่ละกิจกรรม
                                        ผู้เข้าร่วมจะลงทะเบียนเข้าร่วมงานได้เพียงครั้งเดียวเท่านั้น
                                        หากต้องการให้ผู้เข้าร่วม
                                        ลงทะเบียนเข้าร่วมงานทุกวัน/หลายวัน
                                        โปรดสร้างกิจกรรมแยกกัน
                                    </FormHelperText>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    <Divider className={classes.divider} />
                </Grid>
                <div className={classes.title}>เงื่อนไขกิจกรรม</div>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Field
                            name="isPublic"
                            label="การเผยแพร่กิจกรรม"
                            component={RadioToggleButton}
                            options={optionIsPublic}
                            onChange={handleChangeIsPublicResetRelatedFields}
                            xs={12}
                            md={4}
                            required
                        />
                        {isEdit ? (
                            <FormHelperText className={classes.formHelper}>
                                *หากเปลี่ยนรูปแบบการเผยแพร่กิจกรรมจะทำให้ผู้ที่เคยลงทะเบียนล่วงหน้าทั้งหมดถูกยกเลิก
                            </FormHelperText>
                        ) : null}
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            name="reserveFile"
                            component={TextFields}
                            required
                            className={classes.hidden}
                        />
                        <UploadExcelPreRegister
                            handleChangeExcelFile={handleChangeExcelFile}
                            reserveFile={values && values.reserveFile}
                            isPublic={values && values.isPublic}
                            fieldError={
                                submitFailed ? errorState.reserveFile : null
                            }
                            templateURL={RESERVE_FILE_TEMPLATE}
                        />
                    </Grid>
                </Grid>
                {values && values.isPublic ? (
                    // ส่วน เปิดเผยสาธารณะ
                    <>
                        <Grid item xs={12}>
                            <Box
                                className={classes.dateTimeContainer}
                                marginTop={4}
                            >
                                <Field
                                    name="reserveStartDate"
                                    label="วันที่เปิดให้ลงทะเบียนล่วงหน้า"
                                    component={DatePicker}
                                    placeholder="วัน/เดือน/ปี"
                                    required
                                    className={classes.dateTimeContainerField}
                                    onChange={handleChangeDate(
                                        'reserveStartDate'
                                    )}
                                    disabledDateFunction={
                                        disabledReserveStartFunction
                                    }
                                />
                                <Field
                                    name="reserveStartTime"
                                    label="เวลาเริ่มต้น"
                                    component={TimePicker}
                                    placeholder="กรุณาระบุ"
                                    required
                                    className={classes.dateTimeContainerField}
                                    defaultTime={
                                        new Date(
                                            new Date().setHours(0, 0, 0, 0)
                                        )
                                    }
                                />
                                <div
                                    style={{
                                        padding: '6px',
                                        marginTop: '28px',
                                    }}
                                >
                                    ถึง
                                </div>
                                <Field
                                    name="reserveEndDate"
                                    label="วันที่สิ้นสุดลงทะเบียนล่วงหน้า"
                                    component={DatePicker}
                                    placeholder="วัน/เดือน/ปี"
                                    required
                                    className={classes.dateTimeContainerField}
                                    onChange={handleChangeDate(
                                        'reserveEndDate'
                                    )}
                                    disabledDateFunction={
                                        disabledReserveEndFunction
                                    }
                                />
                                <Field
                                    name="reserveEndTime"
                                    label="เวลาสิ้นสุด"
                                    component={TimePicker}
                                    placeholder="กรุณาระบุ"
                                    required
                                    className={classes.dateTimeContainerField}
                                    defaultTime={
                                        new Date(
                                            new Date().setHours(0, 0, 0, 0)
                                        )
                                    }
                                />
                            </Box>
                        </Grid>

                        {/* changed field */}

                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <FormLabel
                                        focused={false}
                                        className={classNames(
                                            classes.label,
                                            {}
                                        )}
                                        component="legend"
                                    >
                                        เงื่อนไขผู้ที่สามารถลงทะเบียนล่วงหน้า
                                        <span className={classes.colorErr}>
                                            {'\u00A0'}*
                                        </span>
                                        <span
                                            className={classes.helperTextLabel}
                                        >
                                            (กรุณาระบุ 0
                                            หากไม่ต้องการให้กลุ่มใดเข้าร่วมกิจกรรม)
                                        </span>
                                    </FormLabel>
                                </Grid>

                                <Grid
                                    container
                                    gap={3}
                                    alignItems="center"
                                    style={{
                                        paddingBottom: !isEdit ? '28px' : '0',
                                    }}
                                >
                                    <Grid item xs={12} md={3}>
                                        <div>พนักงานและลูกจ้างพนักงาน</div>
                                    </Grid>

                                    <Grid item xs={6} md={3}>
                                        <Field
                                            name="internalCapacity"
                                            component={TextFields}
                                            type="number"
                                            className={classes.gridTextField}
                                            disabled={checkedInternal}
                                            placeholder=""
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xs={5}
                                        md={3}
                                        style={{ marginLeft: '16px' }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    color="primary"
                                                    checked={checkedInternal}
                                                    onChange={(e, checked) => {
                                                        setCheckedInternal(
                                                            checked
                                                        );
                                                        if (checked) {
                                                            dispatch(
                                                                change(
                                                                    'internalCapacity',
                                                                    0
                                                                )
                                                            );
                                                            dispatch(
                                                                change(
                                                                    'internalRequired',
                                                                    false
                                                                )
                                                            );
                                                        } else {
                                                            dispatch(
                                                                change(
                                                                    'internalCapacity',
                                                                    0
                                                                )
                                                            );
                                                            dispatch(
                                                                change(
                                                                    'internalRequired',
                                                                    true
                                                                )
                                                            );
                                                        }
                                                    }}
                                                    icon={
                                                        <CheckBoxOutlineBlankIcon
                                                            style={{
                                                                fontSize: 23,
                                                            }}
                                                        />
                                                    }
                                                    checkedIcon={
                                                        <CheckBoxIcon
                                                            style={{
                                                                fontSize: 23,
                                                            }}
                                                        />
                                                    }
                                                    disabled={false}
                                                />
                                            }
                                            label={'ไม่จำกัดจำนวน'}
                                            classes={{
                                                label: classes.fontLabel,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                {isEdit &&
                                    values &&
                                    typeof values.internalReservedCount ===
                                        'number' && (
                                        <Grid
                                            container
                                            style={{
                                                paddingBottom: isEdit
                                                    ? '32px'
                                                    : '0',
                                            }}
                                        >
                                            <Grid item xs={0} md={3}></Grid>
                                            <Grid item xs={12} md={3}>
                                                {
                                                    <FormHelperText
                                                        className={
                                                            classes.reserveFormHelper
                                                        }
                                                        style={{
                                                            marginTop:
                                                                errorState &&
                                                                errorState.internalCapacity &&
                                                                isInternalCapacityTouched
                                                                    ? '18px'
                                                                    : '8px',
                                                        }}
                                                    >
                                                        *มีจำนวนพนักงานและลูกจ้างพนักงาน
                                                        ที่ลงทะเบียนล่วงหน้าแล้ว{' '}
                                                        {
                                                            values.internalReservedCount
                                                        }{' '}
                                                        คน
                                                    </FormHelperText>
                                                }
                                            </Grid>
                                        </Grid>
                                    )}
                                <Grid container gap={3} alignItems="center">
                                    <Grid item xs={12} md={3}>
                                        <div>บุคคลภายนอก</div>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <Field
                                            name="externalCapacity"
                                            component={TextFields}
                                            type="number"
                                            className={classes.gridTextField}
                                            disabled={checkExternal}
                                            placeholder=""
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={5}
                                        md={3}
                                        style={{ marginLeft: '16px' }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    color="primary"
                                                    checked={checkExternal}
                                                    onChange={(e, checked) => {
                                                        setCheckedExternal(
                                                            checked
                                                        );
                                                        if (checked) {
                                                            dispatch(
                                                                change(
                                                                    'externalCapacity',
                                                                    0
                                                                )
                                                            );
                                                            dispatch(
                                                                change(
                                                                    'externalRequired',
                                                                    false
                                                                )
                                                            );
                                                        } else {
                                                            dispatch(
                                                                change(
                                                                    'externalCapacity',
                                                                    0
                                                                )
                                                            );
                                                            dispatch(
                                                                change(
                                                                    'externalRequired',
                                                                    true
                                                                )
                                                            );
                                                        }
                                                    }}
                                                    icon={
                                                        <CheckBoxOutlineBlankIcon
                                                            style={{
                                                                fontSize: 23,
                                                            }}
                                                        />
                                                    }
                                                    checkedIcon={
                                                        <CheckBoxIcon
                                                            style={{
                                                                fontSize: 23,
                                                            }}
                                                        />
                                                    }
                                                    disabled={false}
                                                />
                                            }
                                            label={'ไม่จำกัดจำนวน'}
                                            classes={{
                                                label: classes.fontLabel,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                {isEdit &&
                                    values &&
                                    typeof values.externalReservedCount ===
                                        'number' && (
                                        <Grid
                                            container
                                            style={{
                                                paddingBottom: isEdit
                                                    ? '32px'
                                                    : '0',
                                            }}
                                        >
                                            <Grid item xs={0} md={3}></Grid>
                                            <Grid item xs={12} md={3}>
                                                {
                                                    <FormHelperText
                                                        className={
                                                            classes.reserveFormHelper
                                                        }
                                                        style={{
                                                            marginTop:
                                                                errorState &&
                                                                errorState.externalCapacity &&
                                                                isExternalCapacityTouched
                                                                    ? '18px'
                                                                    : '8px',
                                                        }}
                                                    >
                                                        *มีจำนวนบุคคลภายนอก
                                                        ที่ลงทะเบียนล่วงหน้าแล้ว{' '}
                                                        {
                                                            values.externalReservedCount
                                                        }{' '}
                                                        คน
                                                    </FormHelperText>
                                                }
                                            </Grid>
                                        </Grid>
                                    )}
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <></>
                )}
                <Grid item xs={12} style={{ marginTop: '32px' }}>
                    <Field
                        name="isRequiredCheckin"
                        label="กำหนดรูปแบบการลงทะเบียนเข้างาน"
                        component={RadioToggleButton}
                        options={optionIsRequiredCheckIn}
                        onChange={(event, newValue, previousValue) => {
                            if (newValue === true) {
                                dispatch(change('checkInLeadTime', 30));
                            } else {
                                dispatch(change('checkInLeadTime', null));
                            }
                        }}
                        xs={12}
                        md={4}
                        gap={1}
                        required
                    />
                </Grid>
                {values && values.isRequiredCheckin === true && (
                    <Grid item xs={12} md={6} lg={3}>
                        <Field
                            name="checkInLeadTime"
                            label="เวลาที่เปิดให้ลงทะเบียนเข้างานก่อนเริ่มกิจกรรม (นาที)"
                            component={TextFields}
                            placeholder="กรุณาระบุ"
                            type="number"
                            required
                        />
                    </Grid>
                )}
                <Divider className={classes.divider} />
                <div className={classes.title}>ข้อมูลผู้ดูแลกิจกรรม</div>
                <Grid container>
                    <Grid item md={6} xs={12} lg={3}>
                        <Field
                            name="mainCoordinator"
                            label="ผู้ประสานงานหลัก"
                            component={AutoComplete}
                            options={
                                lutMainCoordinators
                                    ? lutMainCoordinators
                                    : lookups.internalUser
                            }
                            optionKey={{
                                label: 'fullName',
                                value: 'userId',
                            }}
                            disabled={isLookupUserLoading}
                            required
                            isFieldLoading={isLookupUserLoading}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid
                            item
                            md={6}
                            xs={12}
                            lg={3}
                            className={classes.spacing}
                        >
                            <Field
                                id="search-maintainer-event"
                                name="coordinatorTemp"
                                label="ผู้ช่วยจัดกิจกรรม"
                                component={AutoComplete}
                                options={
                                    lutEmpCoordinators
                                        ? lutEmpCoordinators
                                        : lookups.internalUser
                                }
                                optionKey={{
                                    label: 'fullName',
                                    value: 'userId',
                                }}
                                placeholder="กรุณาเลือก"
                                onChangeDropDown={onChangeCoordinatorsForms}
                                isShowNoSelect={false}
                                disabled={isLookupUserLoading}
                                isFieldLoading={isLookupUserLoading}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container direction={'row'}>
                                ผู้ช่วยจัดกิจกรรม :
                                {values &&
                                    Array.isArray(values.coordinators) &&
                                    values.coordinators &&
                                    values.coordinators.map((item, index) => {
                                        return (
                                            <Grid
                                                item
                                                key={`MAINTAINER-${item.name}-${index}`}
                                                className={
                                                    classes.maintainerList
                                                }
                                            >
                                                {item.fullName}
                                                {
                                                    <Fragment>
                                                        <span
                                                            style={{
                                                                color: '#c4c4c4',
                                                                marginLeft:
                                                                    '2px',
                                                            }}
                                                        >
                                                            {' |'}
                                                        </span>
                                                        <IconButton
                                                            aria-label="delete"
                                                            className={
                                                                classes.buttonFab
                                                            }
                                                            onClick={() =>
                                                                onClickRemoveCoordinators(
                                                                    item
                                                                )
                                                            }
                                                        >
                                                            <CloseIcon
                                                                className={
                                                                    classes.extendedIcon
                                                                }
                                                            />
                                                        </IconButton>
                                                    </Fragment>
                                                }
                                            </Grid>
                                        );
                                    })}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
};

export default reduxForm({
    form: formId,
    validate: validateEventForm,
    onSubmitFail: (errors, dispatch, submitError, props) =>
        dispatch(FocusActions.setFocusName(errors, props)),
})(EventCreateEditForm);
